import React, { useEffect } from "react";

const Modal = ({ visible, onClose, children }) => {
    const handleOutsideClick = (e) => {
        if (e.target.id === "modalContainer") {
            onClose?.();
        }
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") {
                onClose?.();
            }
        };

        if (visible) {
            document.addEventListener("keydown", handleEscape);
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div
            id="modalContainer"
            onClick={handleOutsideClick}
            className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50"
        >
            <div onClick={(e) => e.stopPropagation()} className="bg-white p-4 rounded-lg shadow-lg">
                {children}
            </div>
        </div>
    );
};

export default Modal;
